var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIconCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 128,
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-19 -128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0846 131.75 36.9179 131.75 36.9179 134.25 21.0846 134.25Z",
    fill: "#7030A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7096 135.083 21.7096 144.25 36.2929 144.25 36.2929 135.083ZM31.0846 138.417 26.9179 138.417 26.9179 136.75 31.0846 136.75Z",
    fill: "#7030A0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconCategory);
export default __webpack_public_path__ + "static/media/nav-icon-category.05f491c1c7bd06be3198022461761774.svg";
export { ForwardRef as ReactComponent };